class DocumentMapDataPoint {
    constructor(Id, Latitude, Longitude, Name, NodeId, NodeSource) {
        this.Id = Id;
        this.Latitude = Latitude;
        this.Longitude = Longitude;
        this.Name = Name;
        this.NodeId = NodeId;
        this.NodeSource = NodeSource;
    }
}
export default DocumentMapDataPoint;
